import { render, staticRenderFns } from "./FchHc_1d02.vue?vue&type=template&id=7c20d586&"
import script from "./FchHc_1d02.vue?vue&type=script&lang=js&"
export * from "./FchHc_1d02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports